<script setup>
import { ref } from "vue"

const props = defineProps({
  titulo: { type: String, required: true },
  mensaje: { type: String, required: true }
})

const copiado = ref(false)

async function copiar() {
  await navigator.clipboard.writeText(props.mensaje)
  copiado.value = true
  setTimeout(() => (copiado.value = false), 2000)
}
</script>

<template>
  <div v-if="mensaje" class="card mb-3">
    <div class="card-header d-flex justify-content-between align-items-center bg-success-subtle">
      <strong>
        <i class="bi bi-whatsapp text-success me-1"></i>
        {{ titulo }}
      </strong>

      <button type="button" class="btn btn-sm" :class="copiado ? 'btn-success' : 'btn-outline-success'" @click="copiar">
        <i :class="copiado ? 'bi bi-check-lg' : 'bi bi-clipboard'"></i>
        {{ copiado ? "¡Copiado!" : "Copiar" }}
      </button>
    </div>

    <div class="card-body">
      <pre class="mensaje-wa mb-0">{{ mensaje }}</pre>
    </div>
  </div>
</template>

<style scoped>
.mensaje-wa {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 0.92rem;
  background: #f6fef9;
  border-radius: 8px;
  padding: 12px;
}
</style>
